<h2 mat-dialog-title><strong l10nTranslate>Toolbar.Locale.Select Language</strong></h2>

<mat-card>
  
		<h4><span l10nTranslate>Toolbar.Locale.Current Language/Locale</span>: {{ currentCountry }} </h4>

		<mat-dialog-content>
				<mat-form-field>
					<mat-select placeholder="Select Language">
						<mat-option *ngFor="let item of countryMenuItems" (click)="setLocale(item.language, item.country, item.currency, item.numberingSystem);">{{ item.text }}</mat-option>
					</mat-select>
				</mat-form-field>
			</mat-dialog-content>
  

  <mat-card-content>
    <p>

    </p>
  </mat-card-content>
  <mat-card-actions>
		
		<mat-dialog-actions>
			<button mat-raised-button color="primary" l10nTranslate>Toolbar.Locale.Save</button>
			<button mat-button mat-dialog-close l10nTranslate>Toolbar.Locale.Close</button>
		</mat-dialog-actions>
    
  </mat-card-actions>
</mat-card>



